import { cloneDeep } from 'lodash';
import React, { Component } from 'react';

import { session } from 'services/session';
import dashboardService from './dashboard-service';
import { dateService } from '../../../services/date';
import HeroTooltip from './hero-tooltip';
import { formatValue } from '../../base/common/utils';
import { Loader, NoResult } from 'components/misc/loader-utils';

import './change-icons.scss';
import './totals-hero.scss';

class TotalsHero extends Component {
	constructor(props) {
		super(props);

		this.service = dashboardService;
		this.statType = session.isOrgAdmin ?
			'publisher_total_earnings' : 'total_attributed_revenue';
		this.displayName = session.isOrgAdmin ? 'Earnings' : 'Revenue';

		this.state = {
			loading: true,
			showNoResult: false,
			stats: [
				{
					name: 'today',
					label: 'Today',
					diffLabel: ' vs Yesterday',
					value: 0,
					percentChange: 0,
				},
				{
					name: 'this_month',
					label: `${this.displayName} This Month`,
					diffLabel: ' vs Last Month',
					value: 0,
					percentChange: 0,
				},
				{
					name: 'lifetime',
					label: 'Lifetime',
					value: 0,
				},
			],
		};

		this.formatValue = (val) => formatValue(val, 'currency', this.statType);
	}

	componentDidMount() {
		this.queryEarningsStats();
	}

	queryEarningsStats() {
		const dateRange = dateService.getPresetDateRanges().last2Months;
		const params = {
			date_from: dateService.formatDate(dateRange.startDate),
			date_to: dateService.formatDate(dateRange.endDate),
		};

		Promise.all([
			this.service.getLifetimeEarnings(this.props.pubId),
			this.service.getStatsByDay(this.props.pubId, params),
		]).then((resp) => {
			if (!resp[0].length || !resp[1].length) {
				this.showNoResult();
				return;
			}

			this.setState({
				loading: false,
				showNoResult: false,
				stats: this.processStats(...resp),
			});
		}).catch(() => {
			this.showNoResult();
		});
	}

	/* Helper functions */
	processStats(lifetimeStats, dailyStats) {
		const stats = cloneDeep(this.state.stats);
		const lifetime = lifetimeStats[0][this.statType];
		const [month, monthChange] = this.getMonthStat(dailyStats);
		const today = dailyStats[dailyStats.length - 1][this.statType];
		const yesterday = dailyStats[dailyStats.length - 2][this.statType];
		const dailyChange = this.service.calculatePercentChange(
			parseFloat(today), parseFloat(yesterday)
		);

		stats[0].value = this.formatValue(today);
		stats[1].value = this.formatValue(month);
		stats[2].value = this.formatValue(lifetime);
		stats[0].percentChange = dailyChange;
		stats[1].percentChange = monthChange;

		return stats;
	}

	getMonthStat(data) {
		// Divide data into thisMonth and lastMonth
		let lastMonth = 0;
		let thisMonth = 0;
		const currentMonth = new Date().getMonth() + 1; // JS 0-indexes dates

		data.forEach((stat) => {
			const month = parseInt(stat.event_date.split('-')[1]);

			if (month !== currentMonth) {
				lastMonth += parseFloat(stat[this.statType]);
			} else {
				thisMonth += parseFloat(stat[this.statType]);
			}
		});

		const projected = parseFloat(
			(thisMonth / dateService.monthElapsed()).toFixed(2)
		);
		const percentChange = this.service.calculatePercentChange(
			projected, lastMonth
		);

		return [thisMonth, percentChange];
	}

	showNoResult() {
		this.setState({
			showNoResult: true,
			loading: false,
		});
	}

	render() {
		const percentInfo = (stat) => {
			return stat.name !== 'lifetime' ? (
				<div className={`percent-change ${this.service.getRanking(stat.percentChange)}`}>
					<span className="symbol"></span>
					<span className="value">
						{this.service.displayPercentChange(stat.percentChange)}
					</span>
					<span className="comparison">{stat.diffLabel}</span>
				</div>
			) : null;
		};

		const fieldInfo = !this.state.loading && !this.state.showNoResult ?
			this.state.stats.map((stat) => {
				return (
					<div className="totals-hero" key={stat.name}>
						<div className={`field-info ${stat.name}`}>
							<div className={`date-label ${stat.name}`}>
								{stat.label}
							</div>
							<div className={`value ${stat.name}`}>
								{stat.value}
							</div>
							{percentInfo(stat)}
						</div>
					</div>
				);
			}) : null;

		return (
			<div className="totals-hero-container">
				<Loader loading={this.state.loading} />
				<NoResult
					type={`total-${session.isOrgAdmin ? 'earnings' : 'revenue'}`}
					noResult={!this.state.loading && this.state.showNoResult}
				/>
				{fieldInfo}
				<HeroTooltip tooltipType={this.displayName} />
			</div>
		);
	}
}

export default TotalsHero;
